export const HOME = '/';
export const HISTORY = '/history';
export const ABOUTUS = '/aboutus';
export const MOMENTO = '/ourproducts/momento';
export const COFFINO = '/ourproducts/coffino';
export const PRIVATELABLES = '/ourproducts/privatelables';
export const QUICKMAGIC = '/ourproducts/quickmagic';
export const WHYMOMENTO = '/whymomento';
export const CONTACT = '/contact';
export const INNOVATIONS = '/innovations';